import { render, staticRenderFns } from "./SoftbodyModule.vue?vue&type=template&id=069170bc&"
import script from "./SoftbodyModule.vue?vue&type=script&lang=js&"
export * from "./SoftbodyModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports